import type { Corruption } from '../api';

/** Wiki data can outlive a server version; omit absent metadata without inventing a color. */
export function corruptionPresentation(card: Corruption) {
  const cardType = card.cardType === 'Green' || card.cardType === 'Red' ? card.cardType : undefined;
  const signColor = card.signColor === 'White' || card.signColor === 'Black' ? card.signColor : undefined;
  const dimensionSign = typeof card.dimensionSign === 'string' && card.dimensionSign.trim() ? card.dimensionSign : undefined;
  return {
    cardType, signColor, dimensionSign,
    typeLabel: cardType ? `${cardType} Corruption` : 'Corruption',
    signLabel: dimensionSign ? `${signColor ? `${signColor} ` : ''}${dimensionSign} dimension sign` : undefined,
  };
}
